import { Grid, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialTypography from "../../../../components/MaterialTypography";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { useLocation } from "react-router-dom";
import { useLoading } from "../../../../context/loadingcontext";
import axios from "axios";
import { BASE_URL } from "../../../Utils/Baseurl";

const ViewProject = () => {
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const editId = location?.state?.projectId || [];
  const [project, setProject] = useState([]);

  useEffect(() => {
    fetchProjectData();
  }, []);

  const fetchProjectData = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${BASE_URL}api/project/${editId}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data.data;
      setProject(data);
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium" color="dark">
            View Project
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the project here.
          </MaterialTypography>
        </Stack>
      </Stack>

      <Grid container spacing={2} p={2}>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Project Name
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.project_name}
            </MaterialTypography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Project Code
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.project_code}
            </MaterialTypography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Project Manager
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.manager_name}
            </MaterialTypography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Start Date
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.start_date}
            </MaterialTypography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              End Date
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.end_date}
            </MaterialTypography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Milestones
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.milestone}
            </MaterialTypography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Budget
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.budget}
            </MaterialTypography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Team Members
            </MaterialTypography>
            {Array.isArray(project?.resource_allocation) &&
              project.resource_allocation.map((member) => (
                <MaterialTypography
                  key={member.id}
                  variant="h6"
                  color="text"
                  sx={{ fontSize: "14px" }}
                >
                  {member?.employee_name} - {member?.team}
                </MaterialTypography>
              ))}
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Description
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.description}
            </MaterialTypography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Actual Start Date
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.actual_start_date || "NA"}
            </MaterialTypography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <Stack direction="column" spacing={0}>
            <MaterialTypography variant="h6" color="dark">
              Actual End Start
            </MaterialTypography>
            <MaterialTypography
              variant="h6"
              color="text"
              sx={{ fontSize: "14px" }}
            >
              {project.actual_end_date||"NA"}
            </MaterialTypography>
          </Stack>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default ViewProject;
